import Cookies from 'js-cookie';
import {
  CKFINDER_CSRF_TOKEN_KEY,
  COOKIE_NAME_FOR_API_KEY,
  HEADER_NAME_FOR_API_KEY,
  HEADER_NAME_FOR_CKFINDER_CSRF_TOKEN,
} from '../../src/constants/api';
const initCkfinder = (ckfinderConnectorPath) => {
  // XMLHttpRequest.open をオーバーライド（ckfinder.js は改変できないためこの形にしています）
  const originalOpen = XMLHttpRequest.prototype.open;

  XMLHttpRequest.prototype.open = function (method, url, async, user, password) {
    originalOpen.call(this, method, url, async, user, password);

    // セキュリティを考慮してヘッダー内に重要キーをセットする
    if (!this.isCustomHeaderAdded && url.startsWith(ckfinderConnectorPath)) {
      const apiKey = Cookies.get(COOKIE_NAME_FOR_API_KEY);
      const ckCsrfToken = process.env.NODE_ENV !== 'production' ? Cookies.get(CKFINDER_CSRF_TOKEN_KEY) : '';
      const headers = [
        { key: HEADER_NAME_FOR_API_KEY, value: apiKey }, // API キー
        { key: HEADER_NAME_FOR_CKFINDER_CSRF_TOKEN, value: ckCsrfToken }, // CSRF トークン
      ];
      headers.forEach((header) => {
        const headerKey = header.key;
        const headerValue = header.value;
        this.setRequestHeader(headerKey, headerValue);
      });
      this.isCustomHeaderAdded = true;
    }
  };
};
const getCkfinderConnectorPath = () => {
  return process.env.REACT_APP_CKFINDER_BASE_PATH + '/core/connector/php/connector.php';
};
const addCkfinderScriptTag = () => {
  const scriptElement = document.querySelector('#ckfinder-script');
  // CKFinder の script タグが複数追加されるのを回避
  if (!scriptElement) {
    const hostName = location.hostname;
    // [Global_Auth_Domains] （← 他にも存在しているので、変更する際はこのキーで検索してください）
    const productionHostNames = [
      'ext.jp.hondaweb.com',
      'sk.jp.hondaweb.com',
      'dev.ext.jp.hondaweb.com',
      'dev.sk.jp.hondaweb.com',
    ];
    const now = Date.now();
    const scriptUrl = productionHostNames.includes(hostName)
      ? '/ori/ori/ckfinder/ckfinder.js?' + now
      : '/ori/ckfinder/ckfinder.js?' + now;
    const script = document.createElement('script');
    script.src = scriptUrl;
    script.id = 'ckfinder-script';
    document.body.appendChild(script);
  }
};

export { addCkfinderScriptTag, getCkfinderConnectorPath, initCkfinder };
